import { COOKIES } from "@/constants/cookies";
import axios from "axios";
import { parseCookies } from "nookies";

export const apiSearchMs = axios.create({
  baseURL: import.meta.env.VITE_SEARCH_MS_API,
  headers: {
    "auth-token": parseCookies()[COOKIES.BACKOFFICE_AUTH],
    Authorization: `Bearer ${parseCookies()[COOKIES.BACKOFFICE_AUTH]}`,
  },
});

apiSearchMs.interceptors.request.use((config) => {
  const authCookie = parseCookies()[COOKIES.BACKOFFICE_AUTH];

  if (authCookie) {
    config.headers["auth-token"] = authCookie;
    config.headers["Authorization"] = `Bearer ${authCookie}`;
  }

  return config;
});
